import { useCallback, useEffect, useState } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { CallInsightAccordionType } from '../types';

type CallInsightPanelState = {
  defaultAccordion: CallInsightAccordionType | null;
  defaultHighlightedTaskId: string | null;
  showCallIntelInsights: boolean;
  channelId?: string;
};

const getDefaultAccordion = ({
  defaultAccordion,
  showCallIntelInsights,
}: {
  defaultAccordion: CallInsightAccordionType | null;
  showCallIntelInsights: boolean;
}): CallInsightAccordionType | null => {
  if (defaultAccordion === 'callIntel' && !showCallIntelInsights) {
    return 'aboutThisCall';
  }
  return defaultAccordion;
};

export const useCallInsightPanelState = ({
  defaultAccordion,
  defaultHighlightedTaskId,
  showCallIntelInsights,
  channelId,
}: CallInsightPanelState) => {
  const [activeAccordion, setActiveAccordion] = useState<CallInsightAccordionType | null>(() =>
    getDefaultAccordion({ defaultAccordion, showCallIntelInsights })
  );
  const [highlightedTaskId, setHighlightedTaskId] = useState<string | null>(defaultHighlightedTaskId);
  const [unsavedChangesConfig, setUnsavedChangesConfig] = useState<CallIntelTypes.UnsavedEditChangesConfig>({
    actionType: 'NO_ACTION',
    dontAskAgain: false,
    entity: '',
    hasUnsavedChanges: false,
  });

  const handleUnsavedChangesConfig = useCallback(
    (config: CallIntelTypes.UnsavedEditChangesConfig) =>
      setUnsavedChangesConfig((prevConfig) => ({ ...prevConfig, ...config })),
    []
  );

  useEffect(() => {
    setActiveAccordion(getDefaultAccordion({ defaultAccordion, showCallIntelInsights }));
  }, [channelId, defaultAccordion, showCallIntelInsights]);

  return {
    activeAccordion,
    highlightedTaskId,
    unsavedChangesConfig,
    setActiveAccordion,
    setHighlightedTaskId,
    setUnsavedChangesConfig: handleUnsavedChangesConfig,
  };
};
